module.exports = __webpack_public_path__ + "static/media/pdf.3de964e6.png";